// Prefijo de rutas del módulo de presupuestos dentro de la web institucional.
// Todas las páginas y links internos del módulo cuelgan de acá.
export const BASE = '/presupuestos';

// Base URL de la API de presupuestos. Configurable por variable de entorno
// (CRA: REACT_APP_*). En producción, nginx hace reverse proxy de /api/.
export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://dswsolutions.io/api';
